var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgImageSombre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96294 45.7872C8.57159 52.6106 15.7774 55.0625 28.5 55.0625C46.0797 55.0625 53.1262 50.3812 54.7041 35.9541M4.96294 45.7872C2.81013 41.7162 1.9375 36.09 1.9375 28.5C1.9375 8.1875 8.1875 1.9375 28.5 1.9375C48.8125 1.9375 55.0625 8.1875 55.0625 28.5C55.0625 31.2328 54.9494 33.7112 54.7041 35.9541M4.96294 45.7872L14.7056 36.0444C17.1464 33.6037 21.1037 33.6037 23.5444 36.0444L24.0806 36.5806C26.5212 39.0212 30.4787 39.0212 32.9194 36.5806L39.7056 29.7944C42.1462 27.3537 46.1037 27.3537 48.5444 29.7944L54.7041 35.9541M24.4094 18.6437C24.4094 21.8281 21.825 24.4125 18.6406 24.4125C15.4594 24.4125 12.875 21.8281 12.875 18.6437C12.875 15.4594 15.4594 12.875 18.6406 12.875C21.825 12.875 24.4094 15.4594 24.4094 18.6437Z",
    stroke: "#141414",
    strokeOpacity: 0.25098,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImageSombre);
export default __webpack_public_path__ + "static/media/svg_image_sombre.f7116ff301c22ae476208f025606e039.svg";
export { ForwardRef as ReactComponent };